var command = {
	data () {
		return {
			listCommand: [],
			listCommandsJson: [
				{ id: 1, command: 'help', type_command_id: 0, aditionalSearch: false, action_id: null, action: null, parent_command_id: null, created_at: null, update_at: null },
				{ id: 2, command: 'console', type_command_id: 0, aditionalSearch: false, action_id: 1, action: { description: 'Muestra los comandos diponibles' }, parent_command_id: 1 },
				{ id: 3, command: 'back', type_command_id: 0, aditionalSearch: false, action_id: 2, action: { description: 'Realiza la ultima acción' }, parent_command_id: null },
				{ id: 4, command: 'clear', type_command_id: 0, aditionalSearch: false, action_id: null, action: null, parent_command_id: null },
				{ id: 5, command: 'console', type_command_id: 0, aditionalSearch: false, action_id: 3, action: { description: 'Limpia la consola' }, parent_command_id: 4 },
				{ id: 6, command: 'history', type_command_id: 0, aditionalSearch: false, action_id: 4, action: { description: 'Limpia el historial' }, parent_command_id: 4 },
				{ id: 7, command: 'show', type_command_id: 0, aditionalSearch: false, action_id: null, action: null, parent_command_id: null },
				{ id: 8, command: 'history', type_command_id: 0, aditionalSearch: false, action_id: 5, action: { description: 'Muestra en la consola el historial de acciones al hacer enter en un array' }, parent_command_id: 7 },
				{ id: 9, command: 'linear', type_command_id: 0, aditionalSearch: false, action_id: 6, action: { description: 'Muestra en la consola el historial de acciones al hacer enter' }, parent_command_id: 8 },
				{ id: 10, command: 'go', type_command_id: 0, aditionalSearch: false, action_id: null, action: null, parent_command_id: null, created_at: null, update_at: null },
				{ id: 11, command: 'history', type_command_id: 0, aditionalSearch: true, action_id: 7, action: { description: 'Muestra los comandos diponibles' }, parent_command_id: 10 },
				{ id: 12, command: 'ejecute', type_command_id: 0, aditionalSearch: false, action_id: null, action: null, parent_command_id: null, created_at: null, update_at: null },
				{ id: 13, command: 'history', type_command_id: 0, aditionalSearch: true, action_id: 8, action: { description: 'Muestra los comandos diponibles' }, parent_command_id: 12 },
				{ id: 14, command: 'init', type_command_id: 1, aditionalSearch: false, action_id: null, action: null, parent_command_id: null },
				{ id: 15, command: 'module', type_command_id: 1, aditionalSearch: false, action_id: 9, action: { description: 'Inicializa el modulo con los parametros por omision' }, parent_command_id: 14 },
				{ id: 16, command: 'config', type_command_id: 1, aditionalSearch: false, action_id: null, action: null, parent_command_id: null },
				{ id: 17, command: 'module', type_command_id: 1, aditionalSearch: false, action_id: 10, action: { description: 'Abre modal de configuración del modulo' }, parent_command_id: 16 },
				{ id: 18, command: 'new', type_command_id: 2, aditionalSearch: false, action_id: null, action: null, parent_command_id: null },
				{ id: 19, command: 'product', type_command_id: 2, aditionalSearch: false, action_id: 11, action: { description: 'Llama al formulario de producto' }, parent_command_id: 18 },
				{ id: 20, command: 'list', type_command_id: 2, aditionalSearch: false, action_id: null, action: null, parent_command_id: null },
				{ id: 21, command: 'stores', type_command_id: 2, aditionalSearch: true, action_id: 12, action: { description: 'Lista las bodegas' }, parent_command_id: 20 },
				{ id: 22, command: 'print', type_command_id: 2, aditionalSearch: false, action_id: null, action: null, parent_command_id: null, created_at: null, update_at: null },
				{ id: 23, command: 'legal', type_command_id: 2, aditionalSearch: true, action_id: 13, action: { description: 'Muestra ventana de impresión de doumentos legales' }, parent_command_id: 22 },
				{ id: 24, command: 'general', type_command_id: 1, aditionalSearch: false, action_id: 14, action: { description: 'Llama a la  configuración general' }, parent_command_id: 16 },
				{ id: 25, command: 'manifiestos', type_command_id: 2, aditionalSearch: false, action_id: 12, action: { description: 'Lista los manifiestos' }, parent_command_id: 20 },
			],
			search: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		addHistoryInput(s) {
			this.setHistoryInput({id: this.getHistoryInput.length + 1, str: s})
		},
		getCommandsByType(typeIds = [0]) {
			let listCmd = this.listCommandsJson.filter((el) => { return typeIds.includes(parseInt(el.type_command_id))})
			let response = {
				data: {
					success: true,
					data: listCmd
				}
			}
			this.getCommandsByTypeResult(response)
		},
		getCommandsByTypeResult(response) {
			if(response.data.success == true) {
				this.listCommand = response.data.data
			}
			this.getCommandsByTypeResultLocal(response)
		},
		getCommandsByTypeResultLocal(response) {
			console.log('getCommandsByTypeResult no desarrollado', response)
		},
		getCommand(cmd, parent_id = null) {
			cmd = cmd.trim()
			let command = null
			let index = this.getIndexListCommands(cmd, parent_id)
			if(index > -1) {
				if(this.getCommands[index].parent_command_id == parent_id) {
					command = this.getCommands[index]
					command.search = null
				}
			} else {
				let commands = cmd.split(' ')
				if(commands.length > 1) {
					let com1 = this.getCommand(commands[0], parent_id)
					if(com1 != null) {
						let nwCmd = cmd.substring(commands[0].length, cmd.length).trim()
						let com2 = this.getCommand(nwCmd, com1.id)
						if(com2 == null) {
							if(com1.aditionalSearch) {
								com1.search = nwCmd
								command = com1
							} else {
								command = com2
							}
						} else {
							command = com2
						}
					}
				}
			}
			return command
		},
		getIndexListCommands(cmd, parent_id = null) {
			let index = -1
			this.getCommands.forEach((el, ind) => {
				if(el.command.trim().toUpperCase() == cmd.toUpperCase() && el.parent_command_id == parent_id) {
					index = ind
				}
			});
			return index
		},
		internalAction(s) {
			let result = false
			let command = this.getCommand(s)
			if(command != null && command.type_command_id == 0) {
				switch (command.id) {
					case 2:
						if(this.listCommand.length > 0) {
							console.group('Lista de comandos (' + this.getCommands.length + ' en total)')
							this.getCommands.forEach((e) => console.log(e.id + '.- ' + e.command + ': ' + e.action))
							console.groupEnd()
						}
						result = true
						break
					case 3:
						if(this.getHistoryInput.length > 0) {
							this.search = this.getHistoryInput[this.getHistoryInput.length-1].str
							command = this.internalAction(this.search)
							result = false
						} else {
							this.search = ''
						}						
						break
					case 5:
						console.clear()
						result = true
						break
					case 6:
						this.setHistoryInputEmpty()
						result = true
						break
					case 8:
						console.log(this.getHistoryInput)
						result = true
						break
					case 9:
						if(this.getHistoryInput.length > 0) {
							console.group('Historial de busqueda (' + this.getHistoryInput.length + ' en total)')
							this.getHistoryInput.forEach((e) => console.log(e.id + '.- ' + e.str))
							console.groupEnd()
						}
						result = true
						break
					case 11:
					case 13:
						if(command.search != null && !isNaN(command.search) && parseInt(command.search) > 0 && parseInt(command.search) <= this.getHistoryInput.length) {
							this.search = this.getHistoryInput[parseInt(command.search) -1].str
							if(command.id == 13) {
								command = this.internalAction(this.search)
							}
						} else {
							this.search = ''
						}
						result = false
						break
					default:
						break
				}
			}
			if(result) {
				this.addHistoryInput(s)
				this.search = ''
			}

			return command
		},
	},
};

export default command;